import { APP_SUBSCRIPTIONS } from "@lib/config/mercureSubscriptions";
import { AppMercureSubscriber } from "./providers/AppMercureSubscriber";
import { MercureProvider } from "./providers/MercureProvider";
import { ThemeProvider } from "./providers/ThemeProvider";
import ToastProvider from "./providers/ToastProvider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <MercureProvider>
      <AppMercureSubscriber subscriptions={APP_SUBSCRIPTIONS}>
        <ThemeProvider>
          {children}
          <ToastProvider />
        </ThemeProvider>
      </AppMercureSubscriber>
    </MercureProvider>
  );
}
